export default "__VITE_ASSET__9368e5c1__$_?component__"